// /frontend/src/App.js (corregido de nuevo)
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';

// Contextos y hooks
import { useTheme } from './contexts/ThemeContext';

// Layouts
import DashboardLayout from './components/layout/DashboardLayout';
import AuthLayout from './components/layout/AuthLayout';

// Rutas
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import AppRoutes from './routes/AppRoutes';

// Páginas de autenticación
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

// Páginas de error
import NotFound from './pages/errors/NotFound';

import templateConfig from './services/documentService/templateConfig';

function App() {
  // Usar React.useEffect en lugar de solo useEffect
  React.useEffect(() => {
    templateConfig.configurarPlantillas();
  }, []);
  
  const { theme } = useTheme();

  // Crear tema MUI basado en la preferencia del usuario
  const muiTheme = createTheme({
    palette: {
      mode: theme,
      primary: {
        main: '#5D1390',
      },
      secondary: {
        main: '#1cc88a',
      },
    },
  });

  return (
    <ThemeProvider theme={muiTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
        <CssBaseline />
        <Routes>
          {/* Rutas públicas */}
          <Route element={<PublicRoute />}>
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
            </Route>
          </Route>
          
          {/* Rutas privadas */}
          <Route element={<PrivateRoute />}>
            <Route element={<DashboardLayout />}>
              <Route path="/*" element={<AppRoutes />} />
            </Route>
          </Route>
          
          {/* Rutas de error */}
          <Route path="/404" element={<NotFound />} />
          
          {/* Ruta por defecto */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;